const WISHLIST_KEY = 'shopify_wishlist';

// Récupère les favoris en mémoire
function getWishlist() {
  return JSON.parse(localStorage.getItem(WISHLIST_KEY)) || [];
}

// Sauvegarde en mémoire et met à jour la bulle
function setWishlist(array) {
  localStorage.setItem(WISHLIST_KEY, JSON.stringify(array));
  updateWishlistCount();
}

// Met à jour la petite bulle dans le header
function updateWishlistCount() {
  const wishlist = getWishlist();
  const countElement = document.getElementById('wishlist-count');
  const countSpan = countElement ? countElement.querySelector('span') : null;

  if (countElement && countSpan) {
    countSpan.textContent = wishlist.length;
    countElement.style.display = wishlist.length > 0 ? 'flex' : 'none';
  }
}

// Fait fonctionner le bouton sur la fiche produit
function setupWishlistButton() {
  const btn = document.getElementById('add-to-wishlist-btn');
  if (!btn) return;

  const productHandle = btn.getAttribute('data-product-handle');
  let wishlist = getWishlist();
  const svgIcon = btn.querySelector('svg');
  const btnText = btn.querySelector('span');

  if (wishlist.includes(productHandle)) {
    svgIcon.setAttribute('fill', 'currentColor');
    btnText.textContent = 'Retirer des favoris';
  }

  btn.addEventListener('click', function() {
    wishlist = getWishlist();
    if (wishlist.includes(productHandle)) {
      wishlist = wishlist.filter(handle => handle !== productHandle);
      svgIcon.setAttribute('fill', 'none');
      btnText.textContent = 'Ajouter aux favoris';
    } else {
      wishlist.push(productHandle);
      svgIcon.setAttribute('fill', 'currentColor');
      btnText.textContent = 'Retirer des favoris';
    }
    setWishlist(wishlist);
  });
}

// NOUVEAU : Affiche les produits sur la page Favoris
async function renderWishlistPage() {
  const container = document.getElementById('wishlist-container');
  if (!container) return; // S'arrête si on n'est pas sur la page favoris

  const wishlist = getWishlist();

  // Si la liste est vide
  if (wishlist.length === 0) {
    container.innerHTML = `
      <div style="text-align: center; padding: 50px 0;">
        <h2>Votre liste de favoris est vide.</h2>
        <a href="/collections/all" class="button" style="margin-top: 20px;">Continuer mes achats</a>
      </div>`;
    return;
  }

  // Prépare la grille (utilise les styles de base du thème)
  container.innerHTML = '<ul class="grid grid--2-col grid--3-col-tablet grid--4-col-desktop" id="wishlist-grid" style="list-style: none; padding: 0;"></ul>';
  const grid = document.getElementById('wishlist-grid');

  // Va chercher les infos de chaque produit
  for (const handle of wishlist) {
    try {
      const response = await fetch(`/products/${handle}.js`);
      if (!response.ok) continue;
      const product = await response.json();

      const price = (product.price / 100).toFixed(2).replace('.', ',') + ' €';
      const image = product.featured_image || '';

      const li = document.createElement('li');
      li.className = 'grid__item';
      li.innerHTML = `
        <div class="card-wrapper product-card-wrapper" style="text-align: justify;">
          <a href="${product.url}" style="text-decoration: none; color: inherit;">
            <div class="card__inner" style="margin-bottom: 15px;">
              <img src="${image}" alt="${product.title}" style="width: 100%; height: auto; aspect-ratio: 1/1; object-fit: cover; border-radius: 8px;">
            </div>
            <h3 class="h5" style="margin-bottom: 5px;">${product.title}</h3>
            <div class="price" style="margin-bottom: 15px;">${price}</div>
          </a>
          <button class="button button--secondary remove-btn" data-handle="${handle}" style="width: 100%; padding: 10px; min-height: auto; background-color: #28C76F; color: #333; border: none; font-weight: inherit;">Retirer</button>
        </div>
      `;
      grid.appendChild(li);
    } catch (error) {
      console.error('Erreur de chargement pour', handle);
    }
  }

  // Fait fonctionner les boutons "Retirer" de la grille
  const removeBtns = grid.querySelectorAll('.remove-btn');
  removeBtns.forEach(btn => {
    btn.addEventListener('click', function() {
      const handleToRemove = this.getAttribute('data-handle');
      let currentWishlist = getWishlist();
      currentWishlist = currentWishlist.filter(h => h !== handleToRemove);
      setWishlist(currentWishlist);
      renderWishlistPage(); // Recharge la grille
    });
  });
}

// Exécute tout ça quand la page charge
document.addEventListener('DOMContentLoaded', () => {
  updateWishlistCount();
  setupWishlistButton();
  renderWishlistPage(); // On lance l'affichage de la page
});